import PropTypes from 'prop-types';

export const Shape = shape => {
  const propType = PropTypes.shape(shape);
  propType.shape = shape;
  return propType;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SumTypePropType = type => Shape({ cata: PropTypes.func.isRequired });

const Types = {
  ...PropTypes,
};

export const connectionStatus = Types.oneOf([
  'unknown',
  'error',
  'hidden',
  'default',
  'shortlisted',
  'contacted',
  'ignored',
  'ignoredJustNow',
  'blocked',
  'accepted',
  'declined',
  'cancelled',
  'misuseReported',
  'hidden',
  'disabled',
  'sameGender',
  // they
  'theyDeclined',
  'theyAccepted',
  'theyCancelled',
  'theyContacted',
  'skip',
  'filteredContacted',
]);
export const membershipLevel = Types.oneOf(['Free', 'Premium', 'PremiumPlus', 'Select', 'none']);
export const membershipTags = Types.oneOf([
  'free',
  'platinum_plus',
  'diamond_plus',
  'gold_plus',
  'silver_plus',
  'select',
  'vip',
  'gold',
  'diamond',
  'platinum',
  'special',
  'special_plus',
  'solitaire',
  'solitaire_plus',
]);

export const onlineStatus = Types.oneOf(['Online', 'Offline', 'Idle', 'invisible']);
export const contactStatus = Types.oneOf(['none', 'locked', 'available', 'availableOnRequest', 'availableOnVerification', 'showToFreeAndPremium']);
export const horoscopeStatus = Types.oneOf(['none', 'locked', 'available', 'availableOnRequest']);

export const albumStatus = Types.oneOf([
  'default',
  'noPhoto',
  'requestPassword',
  'visibleOnAccept',
  'passwordRequested',
  'photoComingSoon',
  'photoRequestSent',
  'photoUnderScreening',
  'visibleOnUpgrade',
]);
export const isTwoWayMatch = Types.bool;
export const isWatermarked = Types.bool;

export const shortlists = {
  ready: Types.bool.isRequired,
  selected: Types.arrayOf(Types.string).isRequired,
  count: Types.number.isRequired,
};

export const searchFlags = {
  connectionStatus: connectionStatus.isRequired,
  membershipLevel: membershipLevel.isRequired,
  membershipTags: membershipTags.isRequired,
  contactStatus: contactStatus.isRequired,
  horoscopeStatus: horoscopeStatus.isRequired,
  albumStatus: albumStatus.isRequired,
  isTwoWayMatch: isTwoWayMatch.isRequired,
  isWatermarked: isWatermarked.isRequired,
};

export const connectMessage = {
  message_id: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  fullDate: PropTypes.string.isRequired,
  category: PropTypes.oneOf(['sent', 'received']).isRequired,
  type: PropTypes.string.isRequired,
};

export const tooltipBody = {
  key: Types.string.isRequired,
  items: Types.arrayOf(
    Types.shape({
      key: Types.string.isRequired,
      type: Types.oneOf(['link', 'text', 'button']).isRequired,
      text: Types.string.isRequired,
      url: Types.string,
    }),
  ).isRequired,
};

export const tooltip = {
  title: Types.string,
  body: Types.arrayOf(Types.shape(tooltipBody)).isRequired,
  loading: Types.bool,
  position: Types.string.isRequired,
};

export const loadingStyle = Types.oneOf(['none', 'full', 'partial']);

export const album = Types.arrayOf(Types.string.isRequired);

export const baseInfoMapItem = {
  key: Types.string.isRequired,
  value: Types.string.isRequired,
};

export const profileList = {
  flash: Types.string,
  loading: Types.bool.isRequired,
  items: Types.arrayOf(
    Types.shape({
      uid: Types.string.isRequired,
    }),
  ).isRequired,
};

export const profilePagination = {
  count: Types.number,
  prevUrl: Types.string,
  backUrl: Types.string,
  nextUrl: Types.string,
};

export const summaryInfoMapItem = {
  key: Types.string.isRequired,
  label: Types.string.isRequired,
  value: Types.string.isRequired,
};

export const heShe = Types.oneOf(['He', 'She', '...']);
export const himHer = Types.oneOf(['Him', 'Her', '...']);
export const hisHer = Types.oneOf(['His', 'Her', '...']);

export const commonProfile = {
  se: Types.string,
  uid: Types.string,
  name: Types.string,
  slug: Types.string,
  userHandle: Types.string,
  heShe: Types.heShe,
  himHer: Types.himHer,
  hisHer: Types.hisHer,
};

export const summary = {
  infoMap: Types.arrayOf(summaryInfoMapItem).isRequired,
  gridAlbum: album.isRequired,
  listAlbum: album.isRequired,
  shortBio: PropTypes.string.isRequired,
  createdBy: PropTypes.string.isRequired,
};

export const facetOption = {
  id: Types.string.isRequired,
  label: Types.string.isRequired,
  value: Types.string,
  count: Types.string,
  isSelected: Types.bool.isRequired,
};

export const facet = {
  id: Types.string.isRequired,
  options: Types.arrayOf(Types.shape(Types.facetOption)),
  isMulti: Types.bool,
  title: Types.string.isRequired,
};

export const searchProfile = {
  ...commonProfile,
  summary: summary.isRequired,
  flags: searchFlags.isRequired,
};

export const location = {
  hash: Types.string,
  key: Types.string,
  pathname: Types.string.isRequired,
  search: Types.string.isRequired,
};

export const history = {
  action: PropTypes.string.isRequired,
  block: Types.func.isRequired,
  createHref: Types.func.isRequired,
  go: Types.func.isRequired,
  goBack: Types.func.isRequired,
  goForward: Types.func.isRequired,
  length: Types.number.isRequired,
  listen: Types.func.isRequired,
  location: Types.shape(location).isRequired,
  push: Types.func.isRequired,
  replace: Types.func.isRequired,
};

export const sortOrderItem = {
  key: Types.string.isRequired,
  label: Types.string.isRequired,
  isSelected: Types.bool.isRequired,
};

export const shortlistItem = {
  key: Types.string.isRequired,
  id: Types.string.isRequired,
  label: Types.string.isRequired,
};

export const searchItem = {
  uid: Types.string.isRequired,
  eoiTooltip: tooltip.isRequired,
  photoTooltip: tooltip.isRequired,
};

export const results = {
  results_id: Types.string.isRequired,
  permalink: Types.string.isRequired,
  evt_ref: Types.string.isRequired,
  items: Types.arrayOf(Types.shape(Types.searchItem)).isRequired,
};

export const successStory = {
  id: Types.string.isRequired,
  title: Types.string.isRequired,
  description: Types.string.isRequired,
  photo: Types.string.isRequired,
};

export const successStories = {
  loading: Types.bool.isRequired,
  flash: Types.string,
  items: Types.arrayOf(Types.shape(Types.successStory)).isRequired,
};

export const modalTemplate = Types.oneOf([
  'none',
  'watermark',
  'sendRequest',
  'sendDecline',
  'contactDetails',
  'blockMember',
  'reportMisuse',
  'misuseReported',
  'firstStep',
  'dailyRecommendations',
  'pendingExitIntent',
  'history',
  'firstPhotoUpload',
  'uploadPhoto',
  'mostMatchesTour',
  'campaignLayer',
  'inviteDailyLimit',
  'request',
  'viewAlbum',
  'hiddenConnectLayer',
  'callConsultant',
  'saveSearchBox',
  'otherSearch',
  'premiumProposition',
  'profilePhotoUpload',
  'fbPhotoUpload',
  'photoGuidelines',
  'deletePhotoConfirmation',
  'simpleMessage',
  'reportPhoneNo',
  'thankYouPage',
  'accept_match',
  'acceptPremium',
  'contextualPhotoUploadLayer',
]);

export const mobileModalTemplate = Types.oneOf([
  'none',
  'upgrade',
  'sendRequest',
  'premiumProposition',
  'commonInterests',
  'viewContactConfirm',
  'blockProfile',
  'viewContact',
  'reportMisuse',
  'album',
  'facetBar',
  'reportMisuseConfirm',
  'filters',
  'comparePlanDetail',
  'CTALayer',
  'sendRequest_B',
  'whatsappProposition',
]);

export const settings = {
  canSendPasswordOnConnect: PropTypes.bool,
  canConnectWithMessage: PropTypes.bool.isRequired,
  hasUploadedPhoto: Types.bool.isRequired,
  showUpgradeBanner: Types.bool.isRequired,
};

export const hoverCard = {
  uid: Types.string,
  loading: Types.bool.isRequired,
  flash: Types.string,
  tooltip: Types.shape(tooltip).isRequired,
  photoLoading: Types.bool.isRequired,
  eoiLoadingStyle: loadingStyle.isRequired,
};

export const preview = {
  name: Types.string.isRequired,
  flags: PropTypes.shape({
    membershipLevel: membershipLevel.isRequired,
  }).isRequired,
  summary: PropTypes.shape({
    infoMap: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export const fourOFourData = Types.shape({
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  redirectText: PropTypes.string.isRequired,
});

export const fourHourTicker = {
  family_details: PropTypes.bool.isRequired,
  astro: PropTypes.bool.isRequired,
  photo: PropTypes.bool.isRequired,
  career: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  target_time: PropTypes.number.isRequired,
};

export const children = Types.node;

export const skew = {
  socket: PropTypes.number.isRequired,
  api: PropTypes.number.isRequired,
};

export const basicProfile = {
  ...commonProfile,
};

export const chatItem = {
  uid: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  lastMessage: PropTypes.string.isRequired,
  lastMessageDate: PropTypes.string.isRequired,
  lastMessageT: PropTypes.number.isRequired,
  source: PropTypes.oneOf(['api', 'socket']),
  status: PropTypes.oneOf(['delivered', 'read', 'sent', 'none']),
  unreadCount: PropTypes.number,
};
export const onlineItem = {
  uid: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
};

export const chatHistoryMessageItem = {
  messageId: PropTypes.string.isRequired,
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  status: PropTypes.oneOf(['none', 'read', 'sent', 'delivered']),
};

export const image = {
  src: PropTypes.string,
  alt: PropTypes.string,
  title: PropTypes.string,
};

export const match = {
  params: Types.object.isRequired,
  path: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  isExact: PropTypes.bool.isRequired,
};

export const connectContactStatus = Types.oneOf([
  'disabled',
  'sameGender',
  'hidden',
  'contacted',
  'filteredContacted',
  'theyAccepted',
  'theyDeclined',
  'cancelled',
  'blocked',
  'theyContacted',
  'accepted',
  'declined',
  'theyCancelled',
  'theyBlocked',
  'availableOnRequest',
  'none',
]);

export const contactDetailStatus = Types.oneOf([
  'sameGender',
  'currentlyUnderScreening',
  'hidden',
  'theyCancelled',
  'theyDeclined',
  'theyFiltered',
  'notVerified',
  'availableOnRequest',
  'numberHiddenByMember',
  'available',
  'contactDetailNotVerifiedRequested',
  'contactDetailNotVerifiedRequest',
  'membershipContactLimitExceeded',
  'maxContactLimitExceeded',
  'theyCurrentlyUnderScreening',
  'blocked',
  'cancelled',
  'declined',
  'theyCancelled',
  'theyBlocked',
  'theyHidden',
  'disabled',
  'theyAccepted',
  'theyContacted',
  'accepted',
  'contacted',
  'filteredContacted',
  'theyAccepted',
  'none',
]);

export const contactDetailsTitleStatus = Types.oneOf([
  'selfHidden',
  'systemHidden',
  'selfDeleted',
  'systemDeleted',
  'defaultDeleted',
  'available',
  'visibleOnUpgrade',
  'locked',
  'contactDetailNotVerifiedRequested',
  'sameGender',
  'currentlyUnderScreening',
  'hidden',
  'theyCancelled',
  'theyDeclined',
  'theyFiltered',
  'notVerified',
  'numberHiddenByMember',
  'contactDetailNotVerifiedRequest',
  'membershipContactLimitExceeded',
  'maxContactLimitExceeded',
  'theyCurrentlyUnderScreening',
  'blocked',
  'cancelled',
  'declined',
  'theyCancelled',
  'theyBlocked',
  'theyHidden',
  'none',
  'theyAccepted',
  'theyContacted',
  'accepted',
  'contacted',
  'filteredContacted',
  'theyAccepted',
  'unknown',
]);
export const contactSummary = {
  contact: PropTypes.objectOf(
    PropTypes.shape({
      contact_details_status: contactDetailStatus.isRequired,
      contact_details_title_status: contactDetailsTitleStatus.isRequired,
    }),
  ).isRequired,
  profileContactStatus: connectContactStatus.isRequired,
  contactDetailsStatusString: contactDetailStatus.isRequired,
  contactDetailsTitleStatusString: contactDetailsTitleStatus.isRequired,
  actionDate: PropTypes.string.isRequired,
  sms: PropTypes.string.isRequired,
};
export const contactSummaryProfile = {
  ...commonProfile,
  contactSummary: contactSummary.isRequired,
};

export const contactSummaryMeta = {
  loading: PropTypes.bool.isRequired,
};
export const contactSummaryItem = {
  uid: PropTypes.string.isRequired,
  photoLoading: PropTypes.bool.isRequired,
  changeCursorStatus: PropTypes.bool.isRequired,
  viewSmsShowStatus: PropTypes.bool.isRequired,
};
export const contactSummaryMembership = {
  plan: PropTypes.string.isRequired,
  wasPaidUser: PropTypes.bool.isRequired,
};

export const chatOnlineItem = {
  chatDetails: PropTypes.shape({
    device: PropTypes.string.isRequired,
    lastOnline: PropTypes.string.isRequired,
    lastOnlineDetails: PropTypes.string.isRequired,
    lastOnlineText: PropTypes.string.isRequired,
    lastOnlineStatus: PropTypes.string.isRequired,
    platform: PropTypes.string.isRequired,
  }).isRequired,
  name: PropTypes.string.isRequired,
  platform: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
};

export const muiClasses = Types.object;

export const shaadiUser = {
  uid: PropTypes.string.isRequired,
  gender: Types.string.isRequired,
  errusr: Types.string,
};

export const muiOption = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Types.option = PropTypes.arrayOf(Types.muiOption);

export const configApp = {
  appKey: PropTypes.string.isRequired,
  chatAppKey: PropTypes.string.isRequired,
  platform: PropTypes.string.isRequired,
  wwwBaseUrl: PropTypes.string.isRequired,
  domainName: PropTypes.string.isRequired,
  accessToken: PropTypes.string.isRequired,
  autologinToken: PropTypes.string.isRequired,
  authHistoryToken: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
  webp: PropTypes.string.isRequired,
  hasWebpSupport: PropTypes.bool.isRequired,
};

export const reducerSessionUser = {
  // photos: {},
  isLoggedIn: PropTypes.bool.isRequired,
  isLoggedOut: PropTypes.bool.isRequired,
  uid: PropTypes.string.isRequired,
  gender: PropTypes.string.isRequired,
  complexion: PropTypes.string.isRequired,
  built: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  weight: PropTypes.string.isRequired,
  diet: PropTypes.string.isRequired,
  drink: PropTypes.string.isRequired,
  smoke: PropTypes.string.isRequired,
  aboutMe: PropTypes.string.isRequired,
  hasProfilePhoto: false,
  heShe: PropTypes.string.isRequired,
  himHer: PropTypes.string.isRequired,
  hisHer: PropTypes.string.isRequired,
  mrMs: PropTypes.string.isRequired,
  heSheOrYou: PropTypes.string.isRequired,
  himHerOrYou: PropTypes.string.isRequired,
  hisHerOrYou: PropTypes.string.isRequired,
  mrMsOrYou: PropTypes.string.isRequired,
  heSheOrYour: PropTypes.string.isRequired,
  himHerOrYour: PropTypes.string.isRequired,
  hisHerOrYour: PropTypes.string.isRequired,
  mrMsOrYour: PropTypes.string.isRequired,
};

export const reducerSession = {
  areExperimentsFetched: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  isLoggedOut: PropTypes.bool.isRequired,
  nextUrl: PropTypes.string.isRequired,
  isNative: PropTypes.bool.isRequired,
  isStoppage: PropTypes.bool.isRequired,
  canShowSkip: PropTypes.bool.isRequired,
  user: reducerSessionUser.isRequired,
};

export const cartSettings = {
  price: PropTypes.number.isRequired,
  yourPrice: PropTypes.number.isRequired,
  offerDiscountPerc: PropTypes.number.isRequired,
  offerDiscountAmount: PropTypes.number.isRequired,
  discountedPrice: PropTypes.number.isRequired,
  profileBoosterAmount: PropTypes.number.isRequired,
  shaadiCareAmount: PropTypes.number.isRequired,
  isProfileBooster: PropTypes.bool.isRequired,
  isShaadiCare: PropTypes.bool.isRequired,
  isCreditCardMop: PropTypes.bool.isRequired,
  isDebitCardMop: PropTypes.bool.isRequired,
  isPaypalMop: PropTypes.bool.isRequired,
  isNetBankingMop: PropTypes.bool.isRequired,
  isPayAtDoorStepMop: PropTypes.bool.isRequired,
  isPaymentAtBankMop: PropTypes.bool.isRequired,
  isShaadiCentreMop: PropTypes.bool.isRequired,
  isCashPaymentMop: PropTypes.bool.isRequired,
  isEmiMop: PropTypes.bool.isRequired,
  ccConvertedAmount: PropTypes.object.isRequired,
  dcConvertedAmount: PropTypes.object.isRequired,
  paypalConvertedAmount: PropTypes.object.isRequired,
  netBankingConvertedAmount: PropTypes.object.isRequired,
  payAtDoorConvertedAmount: PropTypes.object.isRequired,
  paymentAtBankConvertedAmount: PropTypes.object.isRequired,
  shaadiCenterConvertedAmount: PropTypes.object.isRequired,
  cashPaymentConvertedAmount: PropTypes.object.isRequired,
  emiConvertedAmount: PropTypes.object.isRequired,
  mopIds: PropTypes.shape({
    creditCardId: PropTypes.number.isRequired,
    debitCardId: PropTypes.number.isRequired,
    paypalId: PropTypes.number.isRequired,
    netBankingId: PropTypes.number.isRequired,
    payAtDoorStepId: PropTypes.number.isRequired,
    paymentAtBankId: PropTypes.number.isRequired,
    shaadiCenterId: PropTypes.number.isRequired,
    cashPaymentId: PropTypes.number.isRequired,
    emiId: PropTypes.number.isRequired,
  }).isRequired,
  isShaadiCareAdd: PropTypes.bool.isRequired,
};

export const cartBankList = {
  topBanks: PropTypes.array.isRequired,
  otherBanks: PropTypes.array.isRequired,
};

export const emiBankList = {
  topBanks: PropTypes.array.isRequired,
  allBanks: PropTypes.array.isRequired,
};

export const EmiAddOn = {
  interest: PropTypes.number.isRequired,
  per_month_emi: PropTypes.number.isRequired,
  principal_amount: PropTypes.number.isRequired,
  total_emi: PropTypes.number.isRequired,
};

export const EmiBankOptionsProps = {
  all_addon: PropTypes.shape(Types.EmiAddOn).isRequired,
  cart_default: PropTypes.shape(Types.EmiAddOn).isRequired,
  interest_rate: PropTypes.number.isRequired,
  profile_booster_addon: PropTypes.shape(Types.EmiAddOn).isRequired,
  shaadi_care_addon: PropTypes.shape(Types.EmiAddOn).isRequired,
  tenure: PropTypes.number.isRequired,
};

export const EmiBankProp = {
  bank_code: PropTypes.string.isRequired,
  bank_name: PropTypes.string.isRequired,
  emi_options: PropTypes.arrayOf(Types.EmiBankOptionsProps).isRequired,
};

export const emiDetails = {
  loading: PropTypes.bool.isRequired,
  topBanks: PropTypes.arrayOf(Types.EmiBankProp).isRequired,
  allBanks: PropTypes.arrayOf(Types.EmiBankProp).isRequired,
};

export const cartDoorStepCityList = {
  frequentlyUsedCities: PropTypes.array.isRequired,
  moreCities: PropTypes.array.isRequired,
};

export const cartCentersCityList = {
  cities: PropTypes.array.isRequired,
  centers: PropTypes.array.isRequired,
};

export const cartOtpGenerationData = {
  attempt: PropTypes.number.isRequired,
  errorMsg: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
};

export const cartOtpVerificationData = {
  success: PropTypes.bool.isRequired,
  errorMsg: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
};

export const cartCustomerDetails = {
  mobile: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export const cartVerifiedMobile = {
  isVerifiedMobile: PropTypes.bool.isRequired,
  mobile: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
};

export const cartOrderId = {
  id: PropTypes.string.isRequired,
  errorMsg: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
};

export const jusPayCCFormErrors = {
  cardNum: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  cvv: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  cardHolderName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  cardMonth: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  cardYear: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  trySubmit: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
};

export const jusPayCreditCardCommon = {
  innerRef: PropTypes.func.isRequired,
  formErrors: PropTypes.shape({ ...Types.jusPayCCFormErrors }).isRequired,
};

export const cartTotalPayable = {
  buttonText: PropTypes.string.isRequired,
  isSymbolCodeCurrency: PropTypes.bool.isRequired,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  approxAmount: PropTypes.number.isRequired,
  approxCurrency: PropTypes.string.isRequired,
  isShaadiCareChecked: PropTypes.bool.isRequired,
  isProfileBoosterChecked: PropTypes.bool.isRequired,
  shaadiCare: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  spotlight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isTextVisible: PropTypes.bool,
  isPayAtDoor: PropTypes.bool,
  isCallAssistant: PropTypes.bool,
  isPosCenter: PropTypes.bool,
};

export const cartCommonProps = {
  finalAmount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  settings: PropTypes.shape(PropTypes.cartSettings).isRequired,
  isSymbolCodeCurrency: PropTypes.bool.isRequired,
  isShaadiCareChecked: PropTypes.bool.isRequired,
  isProfileBoosterChecked: PropTypes.bool.isRequired,
};

export const cartSubmitProps = {
  cartId: PropTypes.number.isRequired,
  accessToken: PropTypes.string.isRequired,
  mopId: PropTypes.number.isRequired,
  mopName: PropTypes.string.isRequired,
};

export const cartListProps = Types.oneOfType([
  PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  PropTypes.arrayOf(
    PropTypes.shape({
      bank_code: PropTypes.string.isRequired,
      bank_name: PropTypes.string.isRequired,
      vendor: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  PropTypes.arrayOf(
    PropTypes.shape({
      city_name: PropTypes.string.isRequired,
      display_name: PropTypes.string.isRequired,
      frequently_use: PropTypes.number.isRequired,
      new: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
]);

export const cartDropDownProps = {
  formErrors: PropTypes.oneOfType([
    PropTypes.shape({
      cardNum: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      cvv: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      cardHolderName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      cardMonth: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      cardYear: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    }),
    PropTypes.shape({
      bankName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    }),
    PropTypes.shape({
      address: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      city: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      contactPersonName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      personPhoneNo: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    }),
    PropTypes.shape({
      contactPersonName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      personPhoneNo: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    }),
    PropTypes.shape({
      city: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      centre: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    }),
  ]),
  list: cartListProps.isRequired,
  otherList: cartListProps.isRequired,
};
export const otpHiddenProps = {
  formFields: PropTypes.oneOfType([
    PropTypes.shape({
      city: PropTypes.string.isRequired,
      contactPersonName: PropTypes.string.isRequired,
      personPhoneNo: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
    }),
    PropTypes.shape({
      contactPersonName: PropTypes.string.isRequired,
      personPhoneNo: PropTypes.string.isRequired,
    }),
    PropTypes.shape({
      city: PropTypes.string.isRequired,
      shaadiCentre: PropTypes.string.isRequired,
    }),
  ]),
};

export const orderSuccess = {
  amount: PropTypes.string.isRequired,
  contact_details: PropTypes.string.isRequired,
  crm_no: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  duration: PropTypes.string.isRequired,
  errorMsg: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  mode_of_payment: PropTypes.string.isRequired,
  order_details: PropTypes.arrayOf(
    Types.shape({
      label: Types.string.isRequired,
      text: Types.string.isRequired,
    }),
  ).isRequired,
  order_id: PropTypes.string.isRequired,
  order_status: PropTypes.string.isRequired,
  product: PropTypes.string.isRequired,
  shaadi_care_amount: PropTypes.string,
  sub_sections: PropTypes.arrayOf(
    Types.shape({
      details: PropTypes.arrayOf(
        Types.shape({
          label: PropTypes.string,
          text: PropTypes.string.isRequired,
        }),
      ),
    }),
  ).isRequired,
  extra_discount_days: PropTypes.string.isRequired,
};

export const paymentDetails = {
  currency: PropTypes.string.isRequired,
  showVip: PropTypes.bool.isRequired,
  currentTime: PropTypes.string.isRequired,
  offerType: PropTypes.string.isRequired,
  showSkipLink: PropTypes.bool.isRequired,
  skipProfileId: PropTypes.string.isRequired,
  products: PropTypes.shape({
    personalisedProducts: PropTypes.arrayOf(
      PropTypes.shape({
        best_value: PropTypes.bool.isRequired,
        topseller: PropTypes.bool.isRequired,
        your_plan: PropTypes.bool.isRequired,
        benefits: PropTypes.arrayOf(
          PropTypes.shape({
            description: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
            applicable: PropTypes.bool.isRequired,
          }).isRequired,
        ).isRequired,
        name: PropTypes.string.isRequired,
        discount_text: PropTypes.string.isRequired,
        price: PropTypes.string.isRequired,
        saleprice: PropTypes.string.isRequired,
        pricepermonth: PropTypes.string.isRequired,
        error_msg: PropTypes.string.isRequired,
      }).isRequired,
    ).isRequired,
    premiumProducts: PropTypes.arrayOf(
      PropTypes.shape({
        best_value: PropTypes.bool.isRequired,
        topseller: PropTypes.bool.isRequired,
        your_plan: PropTypes.bool.isRequired,
        benefits: PropTypes.arrayOf(
          PropTypes.shape({
            description: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
            applicable: PropTypes.bool.isRequired,
          }).isRequired,
        ).isRequired,
        name: PropTypes.string.isRequired,
        discount_text: PropTypes.string.isRequired,
        price: PropTypes.string.isRequired,
        saleprice: PropTypes.string.isRequired,
        pricepermonth: PropTypes.string.isRequired,
        error_msg: PropTypes.string.isRequired,
      }).isRequired,
    ).isRequired,
  }).isRequired,
  defaultProduct: PropTypes.string.isRequired,
};

export const paymentData = {
  payment: PropTypes.shape({
    products: PropTypes.shape({
      paymentData: PropTypes.shape({
        topBand: PropTypes.shape({
          isOfferDetail: PropTypes.bool.isRequired,
          isScentTrail: PropTypes.bool.isRequired,
          type: PropTypes.string.isRequired,
          maxDiscount: PropTypes.number.isRequired,
          discountType: PropTypes.string.isRequired,
          showTicker: PropTypes.bool.isRequired,
          validTill: PropTypes.string.isRequired,
          isOldPrice: PropTypes.bool.isRequired,
          profileId: PropTypes.string.isRequired,
          profileName: PropTypes.string.isRequired,
          photo: PropTypes.string.isRequired,
          subText: PropTypes.string.isRequired,
          currency: PropTypes.string.isRequired,
          profileCount: PropTypes.number.isRequired,
          profileImages: PropTypes.arrayOf(
            PropTypes.shape({
              image: PropTypes.string,
              profileid: PropTypes.string,
            }).isRequired,
          ).isRequired,
          extraDiscountText: PropTypes.string.isRequired,
        }).isRequired,
        productDetails: PropTypes.shape(PropTypes.paymentDetails).isRequired,
        userDetails: PropTypes.shape({
          name: PropTypes.string.isRequired,
          email: PropTypes.string.isRequired,
          isFreshdeskUser: PropTypes.bool.isRequired,
        }).isRequired,
        layerColor: PropTypes.string.isRequired,
        offerImage: PropTypes.string.isRequired,
      }).isRequired,
      loading: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};

export const dashBoard = {
  meta: PropTypes.object,
  results: PropTypes.object,
};

export const paymentTabsProps = {
  productDetails: PropTypes.shape(PropTypes.productDetails).isRequired,
  location: PropTypes.shape(PropTypes.location).isRequired,
  addToCart: PropTypes.func.isRequired,
  wwwBaseUrl: PropTypes.string.isRequired,
  cartResult: PropTypes.shape({
    cartErrorMsg: PropTypes.string.isRequired,
    btnloading: PropTypes.bool.isRequired,
  }).isRequired,
};

export const successStoriesProps = {
  stories: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    flash: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        photo: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
  wwwBaseUrl: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['profile', 'search', 'payment']).isRequired,
  isPayment: PropTypes.bool,
  profilePageBucket: PropTypes.string,
  isPaymentPageV3: PropTypes.bool,
  isPremiumTab: PropTypes.bool,
};

export const topBandProps = {
  isOfferDetail: PropTypes.bool.isRequired,
  isScentTrail: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  maxDiscount: PropTypes.number.isRequired,
  discountType: PropTypes.string.isRequired,
  showTicker: PropTypes.bool.isRequired,
  validTill: PropTypes.string.isRequired,
  isOldPrice: PropTypes.bool.isRequired,
  html: PropTypes.string.isRequired,
  profileId: PropTypes.string.isRequired,
  profileName: PropTypes.string.isRequired,
  photo: PropTypes.string.isRequired,
  subText: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  wwwBaseUrl: PropTypes.string.isRequired,
  gender: PropTypes.oneOf(['male', 'female', 'none']).isRequired,
  urlParams: PropTypes.shape({
    acceptCount: PropTypes.number.isRequired,
    profileId: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  extraDiscountText: PropTypes.string.isRequired,
};

export const productProps = {
  name: PropTypes.string.isRequired,
  productCode: PropTypes.string.isRequired,
  tagName: PropTypes.string.isRequired,
  offerType: PropTypes.string.isRequired,
  discountText: PropTypes.string.isRequired,
  discountDetails: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  saleprice: PropTypes.number.isRequired,
  duration: PropTypes.element.isRequired,
  topAmountProps: PropTypes.shape({
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  perMonthAmtProps: PropTypes.shape({
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  isPremiumProduct: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  errorMsg: PropTypes.string.isRequired,
  placeCart: PropTypes.func.isRequired,
  btnloading: PropTypes.bool.isRequired,
};

export const buttonProps = {
  buttonId: PropTypes.string,
  buttonRef: PropTypes.shape({
    current: PropTypes.object,
  }).isRequired,
  isVisibleLoader: PropTypes.bool.isRequired,
  placeOrder: PropTypes.func.isRequired,
  isPosCenter: PropTypes.bool,
  buttonText: PropTypes.string.isRequired,
  step: PropTypes.number.isRequired,
};

export const options = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const settingsPropTypes = {
  isPaidUser: PropTypes.bool,
  offer_details: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const ptpData = {
  ptp: PropTypes.shape({
    cartResult: PropTypes.shape({
      btnloading: PropTypes.bool.isRequired,
      cartErrorMsg: PropTypes.string.isRequired,
    }).isRequired,
    ptpCancelOrder: PropTypes.shape({
      btnloading: PropTypes.bool.isRequired,
    }).isRequired,
    ptpDetails: PropTypes.shape({
      ptpData: PropTypes.shape({
        basicDetails: PropTypes.shape({
          advisorName: PropTypes.string.isRequired,
          advisorNumber: PropTypes.string.isRequired,
          currency: PropTypes.string.isRequired,
          discountCode: PropTypes.string.isRequired,
          isAddDiscountPerc: PropTypes.bool.isRequired,
          isAmountBasedDisount: PropTypes.bool.isRequired,
          name: PropTypes.string.isRequired,
          productCode: PropTypes.string.isRequired,
          productTenure: PropTypes.number.isRequired,
          recordId: PropTypes.number.isRequired,
          userName: PropTypes.string.isRequired,
          productAddonsList: PropTypes.arrayOf(
            PropTypes.shape({
              amount: PropTypes.number,
              description: PropTypes.string,
              discount: PropTypes.number,
              duration: PropTypes.string,
              gst: PropTypes.number,
              name: PropTypes.string,
              product_code: PropTypes.string,
            }),
          ).isRequired,
        }).isRequired,
        productAmount: PropTypes.shape({
          amount: PropTypes.number.isRequired,
        }).isRequired,
        discountAmount: PropTypes.shape({
          amount: PropTypes.number.isRequired,
          percentage: PropTypes.number.isRequired,
        }).isRequired,
        afterDiscountedAmount: PropTypes.shape({
          amount: PropTypes.number.isRequired,
        }).isRequired,
        additionalDiscountAmount: PropTypes.shape({
          amount: PropTypes.number.isRequired,
          percentage: PropTypes.number.isRequired,
        }).isRequired,
        payableAmount: PropTypes.shape({
          amount: PropTypes.number.isRequired,
          percentage: PropTypes.number.isRequired,
          save: PropTypes.number.isRequired,
        }).isRequired,
      }).isRequired,
      loading: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};

export const myOrderData = {
  myorder: PropTypes.shape({
    orders: PropTypes.shape({
      data: PropTypes.arrayOf(
        PropTypes.shape({
          order_id: PropTypes.string,
          mode_of_payment: PropTypes.string,
          status: PropTypes.string,
          date: PropTypes.string,
          currency: PropTypes.string,
          total_payable: PropTypes.string,
          other_discount: PropTypes.string,
          plan_details: PropTypes.arrayOf(
            PropTypes.shape({
              plan: PropTypes.string,
              sort: PropTypes.number,
              amount: PropTypes.string,
              valid_from: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
              valid_to: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            }).isRequired,
          ).isRequired,
        }).isRequired,
      ).isRequired,
      loading: PropTypes.bool.isRequired,
    }).isRequired,
    shaadiCenters: PropTypes.shape({
      cities: PropTypes.array.isRequired,
      centers: PropTypes.array.isRequired,
      loading: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};

export const orderDetailProps = {
  order: PropTypes.shape({
    order_id: PropTypes.string,
    mode_of_payment: PropTypes.string,
    status: PropTypes.string,
    date: PropTypes.string,
    currency: PropTypes.string,
    total_payable: PropTypes.string,
    other_discount: PropTypes.string,
    plan_details: PropTypes.arrayOf(
      PropTypes.shape({
        plan: PropTypes.string,
        sort: PropTypes.number,
        amount: PropTypes.string,
        valid_from: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        valid_to: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }).isRequired,
    ).isRequired,
  }).isRequired,
};
